import { LoginPage } from './ui';

/** Контейнер страницы авторизации. */
export const LoginContainer = LoginPage;

export default LoginContainer;
